import { FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, FormHelperText } from '@mui/material';
import { GENDERS, Gender } from '../../constants/userConstants';

interface GenderMultiSelectProps {
  value: Gender[];
  onChange: (value: Gender[]) => void;
  label?: string;
  helperText?: string;
  required?: boolean;
}

export default function GenderMultiSelect({
  value,
  onChange,
  label = 'Allowed Genders',
  helperText,
  required = false,
}: GenderMultiSelectProps) {
  const handleChange = (gender: Gender) => (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange([...value, gender]);
    } else {
      onChange(value.filter((g) => g !== gender));
    }
  };

  return (
    <FormControl component="fieldset" required={required}>
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup row>
        {GENDERS.map((option) => (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                checked={value.includes(option.value as Gender)}
                onChange={handleChange(option.value as Gender)}
              />
            }
            label={option.label}
          />
        ))}
      </FormGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
